import { createSlice } from '@reduxjs/toolkit';

const footerSlice = createSlice({
  name: 'footer',
  initialState: { isFooterReady: false },
  reducers: {
    setFooterReady: (state, action) => {
      state.isFooterReady = action.payload;
    },
  },
});

export const { setFooterReady } = footerSlice.actions;
export default footerSlice.reducer; 